import React from "react";
import { Navigate } from "react-router-dom";
import Swal from "sweetalert2";

export default function ProtectedAdmin(props) {

  if (localStorage.getItem("role") ==="admin") {
    return props.children
  } else {
    Swal.fire({
                title: "Error!",
                text: "You can't access to this page",
                icon: "error",
                confirmButtonColor: "#d33",
              });
    return <Navigate to={'/'}/>
  }
}
